export const DEMOGRAPHICS_REPORT_GET_SITE_GROUPS =
  'DEMOGRAPHICS_REPORT_GET_SITE_GROUPS';
export const DEMOGRAPHICS_REPORT_FETCHING = 'DEMOGRAPHICS_REPORT_FETCHING';
export const DEMOGRAPHICS_REPORT_FETCH_ERROR =
  'DEMOGRAPHICS_REPORT_FETCH_ERROR';
export const DEMOGRAPHICS_REPORT_GET_GRADES = 'DEMOGRAPHICS_REPORT_GET_GRADES';
export const DEMOGRAPHICS_REPORT_GET_REPORT = 'DEMOGRAPHICS_REPORT_GET_REPORT';



// WEBPACK FOOTER //
// ./src/pages/demographics/state/demographicsreport/types.js